export default __webpack_public_path__ + "static/media/cta-chiriasi.86528bf1.jpg";